module.exports = __webpack_public_path__ + "img/logo.4587ec92.png";